import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { compose } from 'recompose'
import ImmutablePropTypes from 'react-immutable-proptypes'
import { connect as connectRedux } from 'react-redux'
import {
  connect as connectPage,
  PAGE_SEO_TYPE_MANUAL,
} from '../Page/connect'
import { getBoundActions } from '../../actions/index'
import { getSeo } from '../../services/url/index'
import MemberHome from '../MemberHome/index'
import Home from '../Home/index'

function updateSeo (props) {
  // @TODO replace with connectedPage HOC
  const {
    page, auth, location, setPageSeo,
  } = props
  const path = location.pathname + String(location.search)
  if (page.get('path') === path) {
    return
  }
  const seo = getSeo({
    pathname: location.pathname,
    loggedIn: !!auth.get('jwt'),
  })
  setPageSeo({
    title: seo.title,
    description: seo.description,
    noFollow: seo.noFollow,
    noIndex: seo.noIndex,
    location,
  })
}

class IndexPage extends Component {
  componentDidMount () {
    updateSeo(this.props)
  }

  componentDidUpdate (prevProps) {
    const { auth: nextAuth } = this.props
    const { auth: prevAuth } = prevProps
    if (process.env.BROWSER && !nextAuth.equals(prevAuth)) {
      updateSeo(this.props)
    }
  }

  render () {
    const { props } = this
    const { auth, location, history } = props

    if (auth.get('jwt')) {
      return (
        <MemberHome
          location={props.location}
          history={props.history}
        />
      )
    }
    return <Home history={history} location={location} />
  }
}

IndexPage.propTypes = {
  auth: ImmutablePropTypes.map.isRequired,
  page: ImmutablePropTypes.map.isRequired,
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  setPageSeo: PropTypes.func.isRequired,
}

export default compose(
  connectRedux(
    (state) => ({
      auth: state.auth,
      page: state.page,
    }),
    (dispatch) => {
      const actions = getBoundActions(dispatch)
      return {
        setPageSeo: actions.page.setPageSeo,
      }
    },
  ),
  connectPage({ seoType: PAGE_SEO_TYPE_MANUAL }),
)(IndexPage)
